import L, { PointTuple } from 'leaflet';
import { areaMarkerUrl, dpeMarkerUrl, dpeCombinedMarkerUrl } from './constant';

function getMarkerIcon(url: string, size?: PointTuple) {
  const iconSize = size ?? [24, 36];
  return L.icon({
    iconUrl: url,
    iconSize: iconSize,
    iconAnchor: [iconSize[0] / 2, iconSize[1]], // Center horizontally, bottom vertically
  });
}
function adMarkerBuilder(data: AdMarkerDatas): AdMarkerDatas {
  let url = '';

  if (data.types.includes('dpe-area-combined')) {
    url = dpeCombinedMarkerUrl;
  } else if (data.types.includes('area')) {
    url = areaMarkerUrl;
  } else if (data.types.includes('dpe')) {
    url = dpeMarkerUrl;
  }

  const adMarker: AdMarkerDatas = {
    ...data,
    icon: getMarkerIcon(url),
  };

  return adMarker;
}
function adMarkersBuilder(datas: any[]): AdMarkersDatas {
  return datas.map((m) => adMarkerBuilder(m));
}

export { adMarkerBuilder, adMarkersBuilder, getMarkerIcon };
